var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60156 20.4C3.60156 19.7373 4.13882 19.2 4.80156 19.2H19.2016C19.8643 19.2 20.4016 19.7373 20.4016 20.4C20.4016 21.0627 19.8643 21.6 19.2016 21.6H4.80156C4.13882 21.6 3.60156 21.0627 3.60156 20.4ZM7.55303 8.04853C7.08441 7.5799 7.08441 6.8201 7.55303 6.35147L11.153 2.75147C11.3781 2.52643 11.6833 2.4 12.0016 2.4C12.3198 2.4 12.625 2.52643 12.8501 2.75147L16.4501 6.35147C16.9187 6.8201 16.9187 7.5799 16.4501 8.04853C15.9815 8.51716 15.2217 8.51716 14.753 8.04853L13.2016 6.49706L13.2016 15.6C13.2016 16.2627 12.6643 16.8 12.0016 16.8C11.3388 16.8 10.8016 16.2627 10.8016 15.6L10.8016 6.49706L9.25009 8.04853C8.78146 8.51716 8.02166 8.51716 7.55303 8.04853Z",
    fill: "#FDFDFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.c6e3ab34874aae9e079618e84af00177.svg";
export { ForwardRef as ReactComponent };